import React from 'react'
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material'
import PieChartComponent from '../components/Charts/PieChart'
import { useApiData } from '../hooks/useApiData'
import { apiService } from '../services/api'
import { ChartData } from '../types'

const PieChartPage: React.FC = () => {
  const {
    data: chartData,
    loading,
    error
  } = useApiData<ChartData[]>(apiService.fetchPieChartData, [])

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box>
      <Typography
        variant={isMobile ? 'h6' : 'h5'}
        gutterBottom
        sx={{
          fontWeight: 600,
          fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.5rem' }
        }}>
        Usage Statistics
      </Typography>
      <PieChartComponent
        data={chartData || []}
        loading={loading}
        error={error}
      />
    </Box>
  )
}

export default PieChartPage
